module.exports = __webpack_public_path__ + "static/car-0df38122bb01ce94c25770ee744cb0b8.jpg";